module.exports = __webpack_public_path__ + "img/IMG_20191126_235630.f6ca0a25.jpg";